import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0A1628] border-t border-[#00FFD1]/20 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid md:grid-cols-3 gap-8 items-center">
          {/* Left - Logo */}
          <div className="flex items-center gap-3 justify-center md:justify-start">
            <img 
              src="https://public.readdy.ai/ai/img_res/2de32bf8-6894-4f4a-ba90-b9480aaa88cf.png" 
              alt="WingmanFix Logo" 
              className="h-8 w-8 object-contain"
            />
            <span className="text-lg font-bold">WingmanFix</span>
          </div>

          {/* Center - Navigation Links */}
          <div className="flex flex-wrap justify-center gap-4 sm:gap-8">
            <Link to="/features" className="text-sm text-gray-400 hover:text-[#00FFD1] transition-colors uppercase tracking-wider cursor-pointer whitespace-nowrap">
              Features
            </Link>
            <Link to="/pricing" className="text-sm text-gray-400 hover:text-[#00FFD1] transition-colors uppercase tracking-wider cursor-pointer whitespace-nowrap">
              Pricing
            </Link>
            <Link to="/for-cfis" className="text-sm text-gray-400 hover:text-[#00FFD1] transition-colors uppercase tracking-wider cursor-pointer whitespace-nowrap">
              For CFIs
            </Link>
            <Link to="/safety" className="text-sm text-gray-400 hover:text-[#00FFD1] transition-colors uppercase tracking-wider cursor-pointer whitespace-nowrap">
              Safety
            </Link>
            <Link to="/terms" className="text-sm text-gray-400 hover:text-[#00FFD1] transition-colors uppercase tracking-wider cursor-pointer whitespace-nowrap">
              Terms
            </Link>
            <Link to="/privacy" className="text-sm text-gray-400 hover:text-[#00FFD1] transition-colors uppercase tracking-wider cursor-pointer whitespace-nowrap">
              Privacy
            </Link>
            <a href="mailto:support@wingmanfix.com" className="text-sm text-gray-400 hover:text-[#00FFD1] transition-colors uppercase tracking-wider cursor-pointer whitespace-nowrap">
              Contact
            </a>
          </div>

          {/* Right - Tagline */}
          <div className="text-center md:text-right">
            <p className="text-sm text-gray-400 italic">Built by pilots, for pilots.</p>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-800 text-center">
          <p className="text-xs text-gray-600">
            © 2024 WingmanFix. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}